module.exports = __webpack_public_path__ + "static/media/inframeterxt-3.42433ab5.jpg";